export const playgroundContent = {
  title: 'Playground de testes',
  description:
    'Teste uma pergunta como se fosse enviada por um cliente antes de ativar a IA nos canais reais.',
  emptyAgentTitle: 'Nenhum agente IA configurado.',
  emptyAgentDescription:
    'Configure um provedor e um agente antes de testar respostas.',
  agentLabel: 'Agente IA',
  agentFallbackLabel: 'Selecione um agente',
  agentContextSeparator: ' · ',
  questionTitle: 'Pergunta do cliente',
  questionDescription:
    'Digite uma dúvida comum para validar como a IA responderia.',
  questionLabel: 'Mensagem',
  questionPlaceholder: 'Ex: Qual é o horário de funcionamento?',
  defaultQuestion: 'Qual é o horário de funcionamento?',
  submitLabel: 'Testar resposta',
  testingLabel: 'Testando...',
  resultTitle: 'Resposta da IA',
  resultDescription:
    'Essa é a resposta simulada que o assistente enviaria ao cliente.',
  knowledgeTitle: 'Base usada nesta resposta',
  detailsTitle: 'Detalhes da simulação',
  settingsTitle: 'Configurações aplicadas nesta simulação',
  actionsTitle: 'Ações que a IA poderia sugerir',
  emptyActions: 'Nenhuma ação sugerida para esta simulação.',
  emptyKnowledge: 'Nenhum documento da base foi usado nesta resposta.',
  showDetailsLabel: 'Detalhes',
  hideDetailsLabel: 'Ocultar',
  enabledLabel: 'Sim',
  disabledLabel: 'Não',
  emptyValueLabel: '-',
  noEnabledActionsLabel: 'Nenhuma ação habilitada',
  noEnabledSafetySettingsLabel: 'Nenhuma trava habilitada',
  noPolicyLabel: 'Sem regra definida',
  settingsLabels: {
    model: 'Modelo:',
    temperature: 'Criatividade:',
    maxTokens: 'Tokens máximos:',
    autonomy: 'Autonomia:',
    autoReply: 'Resposta automática:',
    humanHandoff: 'Transferência humana:',
    tone: 'Tom:',
    instructions: 'Instruções:',
    greetingMessage: 'Mensagem inicial:',
    handoffMessage: 'Mensagem de transferência:',
    agent: 'Agente:',
    inbox: 'Inbox:',
    channel: 'Canal:',
    enabledActions: 'Ações habilitadas:',
    safetySettings: 'Travas de segurança:',
  },
};

export const getAgentOptions = agents => {
  return agents.map(agent => ({
    label: `${agent.name} — ${agent.inbox_name || 'Sem inbox'}`,
    value: String(agent.id),
  }));
};

export const getSelectedAgentLabel = (agents, selectedAgentId) => {
  return (
    getAgentOptions(agents).find(
      option => option.value === String(selectedAgentId)
    )?.label || playgroundContent.agentFallbackLabel
  );
};

export const formatAutonomyLevel = value => {
  const labels = {
    respond_only: 'Apenas responder',
    respond_and_organize: 'Responder e organizar',
    respond_and_execute: 'Responder e executar ações',
  };

  return labels[value] || value || playgroundContent.noPolicyLabel;
};

export const formatChannelType = value => {
  const labels = {
    'Channel::Whatsapp': 'WhatsApp',
    'Channel::Api': 'Canal da API',
    'Channel::WebWidget': 'Widget do site',
  };

  return labels[value] || value || playgroundContent.emptyValueLabel;
};
